import React from "react";
import { Modal } from "react-bootstrap";

export default function ModalWithoutTitle({ show, onHide, children }) {
  return (
    <>
      <Modal
        className="student manager white inmodal auto without-overflow"
        show={show}
        onHide={onHide}
      >
        <Modal.Header>
          <button className="close" type="button" onClick={onHide}>
            <span aria-hidden="true">&times;</span>
            <span className="sr-only">Close</span>
          </button>
          {children}
        </Modal.Header>
      </Modal>
    </>
  );
}
